import React, {
    useState,
    useContext,
    useCallback,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    useModal,
} from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from 'gw-portals-viewmodel-react';
import { messages as commonMessages } from 'gw-platform-translations';
import ServiceRequestService from 'gw-capability-servicerequest/services/ServiceRequestService';
import messages from './SearchServiceOrClaimPopup_AX.messages';
import metadata from './SearchServiceOrClaimPopup_AX.metadata.json5';

function SearchServiceOrClaimPopup(props) {
    const {
        isOpen,
        onReject,
        updateResults,
        authHeader,
        history
    } = props;

    const [searchInputDTO, setSearchInputDTO] = useState({
        searchInput: ''
    });


    const { refreshData } = useDataRefresh();
    const {
        showAlert
    } = useModal();
    const translator = useContext(TranslatorContext);

    const writeValue = useCallback(
        (value) => {
            setSearchInputDTO(value);
            refreshData();
        },
        [searchInputDTO, refreshData]
    );

    const handleClose = useCallback(async () => {
        onReject();
    }, []);

    const handleSearch = useCallback(async () => {
        ServiceRequestService.getServiceRequestForClaimOrServiceAX(
            searchInputDTO.searchInput, authHeader
        ).then(
            (searchResultsList) => {
                const resultsCount = Object.keys(searchResultsList).length;
                if (resultsCount > 0) {
                    if (resultsCount === 1) {
                        const servRequestNumber = searchResultsList[0].serviceRequestNumber;
                        history.push(`/service-request-details/${servRequestNumber}`);
                        handleClose();
                    } else {
                        updateResults(searchResultsList);
                        handleClose();
                    }
                } else {
                    showAlert({
                        title: translator(messages.noResultsFoundAlertTitle),
                        message: translator(messages.noResultsFoundAlertMessage),
                        status: 'warning',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                }
            }
        ).catch((e) => {
            showAlert({
                title: translator(messages.errorCCCommunicationAlertTitle),
                message: e.baseError,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        });
    }, [history]);

    const handleEnterKey = useCallback(async () => {
        if (searchInputDTO.searchInput.length > 0) {
            handleSearch();
        }
    }, []);

    const overrides = {
        '@field': {
            onEnter: handleEnterKey
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            valueChangeFn: writeValue
        }
    };

    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader title={translator(messages.searchInputTitle)} />
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.componentContent.content}
                    model={searchInputDTO}
                    callbackMap={resolvers.resolveCallbackMap}
                    onModelChange={writeValue}
                    overrideProps={overrides}
                />
            </ModalBody>
            <ModalFooter>
                <Button type="text" onClick={handleClose}>
                    {translator(messages.cancelButton)}
                </Button>
                <Button onClick={handleSearch} disabled={searchInputDTO.searchInput.length === 0}>
                    {translator(messages.searchButton)}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

SearchServiceOrClaimPopup.propTypes = {
    isOpen: PropTypes.bool,
    onReject: PropTypes.func,
    updateResults: PropTypes.func.isRequired,
};

SearchServiceOrClaimPopup.defaultProps = {
    isOpen: false,
    onReject: _.noop,
};

export default SearchServiceOrClaimPopup;
